import { createFormContext } from "@mantine/form";
import { Asserts } from "yup";
import desafioFormSchema from "../../schema";

type FormInputs = Asserts<typeof desafioFormSchema>;

const [DesafioFormProvider, useDesafioFormContext, useDesafioForm] = createFormContext<FormInputs>();

export { DesafioFormProvider, useDesafioFormContext, useDesafioForm };
